import React from 'react';
import { Icon } from '../components/Icon';
import './WelcomeScreen.css';
import { useTranslation } from 'react-i18next';

export const WelcomeScreen: React.FC = () => {
  const { t } = useTranslation();
  const handleGetStarted = () => {
    // Редирект на Telegram бота
    window.location.href = 'https://t.me/alveon_finance_bot';
  };

  const handleWebAppLogin = () => {
    // Переход к странице логина через параметр URL
    // Используем перезагрузку страницы для гарантированной работы логики в App.tsx
    console.log('🔵 [WelcomeScreen] handleWebAppLogin called, redirecting to /?login=true');
    window.location.href = '/?login=true';
  };

  return (
    <div className="welcome-screen">
      <div className="welcome-content">
        {/* Логотип */}
        <div className="welcome-logo-container">
          <img 
            src="/logo.png" 
            alt="Alveon Logo"
            className="welcome-logo-image"
            onError={(e) => {
              const target = e.target as HTMLImageElement;
              if (target.src.includes('logo.png')) {
                target.src = '/android-chrome-512x512.png';
              } else if (target.src.includes('android-chrome-512x512.png')) {
                target.src = '/android-chrome-192x192.png';
              } else {
                target.style.display = 'none';
                const parent = target.parentElement;
                if (parent && !parent.querySelector('.welcome-logo-fallback')) {
                  const fallback = document.createElement('div');
                  fallback.className = 'welcome-logo-fallback';
                  fallback.innerHTML = `
                    <svg width="160" height="160" viewBox="0 0 440.000000 440.000000" preserveAspectRatio="xMidYMid meet">
                      <g transform="translate(0.000000,440.000000) scale(0.100000,-0.100000)" fill="#2d3748">
                        <path d="M2122 3569 c-65 -12 -144 -52 -183 -91 -27 -27 -297 -419 -319 -463 -3 -5 -86 -131 -184 -280 -216 -326 -363 -549 -441 -670 -32 -49 -77 -119 -100 -155 -134 -206 -225 -363 -240 -416 -25 -82 -24 -221 3 -295 36 -102 101 -186 202 -264 73 -56 156 -90 257 -106 71 -11 92 -10 169 5 94 19 213 69 264 112 53 45 137 159 370 503 l43 64 96 -5 c167 -8 207 -37 341 -246 47 -73 102 -158 122 -190 20 -31 50 -80 67 -108 41 -69 87 -112 130 -124 47 -13 546 -13 636 0 92 14 181 63 267 148 121 119 172 270 148 440 -11 82 -26 110 -205 382 -67 102 -184 284 -260 405 -76 121 -146 231 -155 245 -29 44 -82 127 -315 495 -297 469 -307 485 -346 521 -93 85 -231 120 -367 93z"/>
                      </g>
                    </svg>
                  `;
                  parent.insertBefore(fallback, target);
                }
              }
            }}
          />
          <h1 className="welcome-logo-text">Alveon</h1>
        </div>

        <p className="welcome-subtitle-text">
          {t('welcome.subtitle')}
        </p>

        {/* Ключевые возможности */}
        <div className="welcome-features">
          <div className="welcome-feature">
            <Icon name="trending-up" size={20} color="#1C78FF" />
            <span>{t('welcome.features.expenses.title')}</span>
          </div>
          <div className="welcome-feature">
            <Icon name="pie-chart" size={20} color="#1C78FF" />
            <span>{t('welcome.features.categorization.title')}</span>
          </div>
          <div className="welcome-feature">
            <Icon name="target" size={20} color="#1C78FF" />
            <span>{t('welcome.features.goals.title')}</span>
          </div>
          <div className="welcome-feature">
            <Icon name="bar-chart" size={20} color="#1C78FF" />
            <span>{t('welcome.features.analytics.title')}</span>
          </div>
        </div>

        {/* Разделитель */}
        <div className="welcome-divider"></div>

        {/* Описание */}
        <div className="welcome-description">
          <p className="welcome-description-text">
            {t('welcome.appDescription')}
          </p>
        </div>

        {/* Основная кнопка */}
        <button
          onClick={handleWebAppLogin}
          className="welcome-action-button welcome-action-button--primary"
        >
          <Icon name="globe" size={20} color="#FFFFFF" />
          <span className="welcome-action-button-text">{t('welcome.loginToWebApp')}</span>
        </button>

        {/* App Store & Google Play Buttons */}
        <div className="welcome-store-buttons">
            <a
              href="https://apps.apple.com/app/alveon-expense-income-track/id6755163975"
              target="_blank"
              rel="noopener noreferrer"
              className="welcome-store-button welcome-store-button--apple"
            >
              <img 
                src="/app-store-button.svg" 
                alt="Download on the App Store"
                className="welcome-store-button__image"
                onError={(e) => {
                  const target = e.target as HTMLImageElement;
                  // Fallback на PNG если SVG не загрузился
                  if (target.src.includes('.svg')) {
                    target.src = '/app-store-button.png';
                  } else {
                    // Если и PNG не загрузился - показываем текстовую кнопку
                    target.style.display = 'none';
                    const parent = target.parentElement;
                    if (parent && !parent.querySelector('.welcome-store-button-fallback')) {
                      const fallback = document.createElement('div');
                      fallback.className = 'welcome-store-button-fallback';
                      fallback.style.cssText = 'display: flex; align-items: center; justify-content: center; gap: 8px; height: 50px; background: #000; color: #fff; border-radius: 8px; padding: 0 16px; font-size: 12px; font-weight: 600;';
                      fallback.innerHTML = `
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
                          <path d="M17.05 20.28c-.98.95-2.05.88-3.08.4-1.09-.5-2.08-.48-3.24 0-1.44.62-2.2.44-3.06-.4C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/>
                        </svg>
                        <span>Download on the<br>App Store</span>
                      `;
                      parent.appendChild(fallback);
                    }
                  }
                }}
              />
            </a>
            
            <a
              href="https://play.google.com/store/apps/details?id=com.alveon.alveonfinance"
              target="_blank"
              rel="noopener noreferrer"
              className="welcome-store-button welcome-store-button--google"
            >
              <img 
                src="/google-play-button.svg" 
                alt="GET IT ON Google Play"
                className="welcome-store-button__image"
                onError={(e) => {
                  const target = e.target as HTMLImageElement;
                  // Fallback на PNG если SVG не загрузился
                  if (target.src.includes('.svg')) {
                    target.src = '/google-play-button.png';
                  } else {
                    // Если и PNG не загрузился - показываем текстовую кнопку
                    target.style.display = 'none';
                    const parent = target.parentElement;
                    if (parent && !parent.querySelector('.welcome-store-button-fallback')) {
                      const fallback = document.createElement('div');
                      fallback.className = 'welcome-store-button-fallback';
                      fallback.style.cssText = 'display: flex; align-items: center; justify-content: center; gap: 8px; height: 50px; background: #000; color: #fff; border-radius: 8px; padding: 0 16px; font-size: 12px; font-weight: 600;';
                      fallback.innerHTML = `
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                          <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z" fill="#4285F4"/>
                          <path d="M20.16,10.81L17.89,9.5L15.39,12L17.89,14.5L20.18,13.18C20.53,12.9 20.75,12.5 20.75,12C20.75,11.5 20.5,11.08 20.16,10.81Z" fill="#34A853"/>
                          <path d="M3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15Z" fill="#EA4335"/>
                          <path d="M16.81,8.88L6.05,2.66L14.54,11.15L16.81,8.88Z" fill="#FBBC04"/>
                        </svg>
                        <span>GET IT ON<br>Google Play</span>
                      `;
                      parent.appendChild(fallback);
                    }
                  }
                }}
              />
            </a>

            <a
              href="https://t.me/alveon_finance_bot"
              target="_blank"
              rel="noopener noreferrer"
              className="welcome-store-button welcome-store-button--telegram"
            >
              <div className="welcome-telegram-button-content">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="#FFFFFF">
                  <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/>
                </svg>
                <span>Telegram</span>
              </div>
            </a>
          </div>

        {/* Footer */}
        <footer className="welcome-footer">
          <div className="welcome-footer-links">
            <a href="https://alveon.app/privacy" target="_blank" rel="noopener noreferrer" className="welcome-footer-link">{t('welcome.privacyPolicy')}</a>
            <span className="welcome-footer-separator">•</span>
            <a href="https://alveon.app/terms/" target="_blank" rel="noopener noreferrer" className="welcome-footer-link">{t('welcome.termsOfService')}</a>
            <span className="welcome-footer-separator">•</span>
            <a href="mailto:support@alveon.app" className="welcome-footer-link">{t('welcome.contact')}</a>
          </div>
          <p className="welcome-footer-copyright">{t('welcome.copyright')}</p>
        </footer>
      </div>
    </div>
  );
};
